import { render, staticRenderFns } from "./BookmakerJoinButton.vue?vue&type=template&id=6ef03c2e"
import script from "./BookmakerJoinButton.vue?vue&type=script&lang=js"
export * from "./BookmakerJoinButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports